import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { environment } from '../../../../environments/environment';

const RewardCard = ({ title, value, subtitle }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '10px',
        border: '1px solid #FD562233',
        width: '100%',
        background: '#F3F6F9',
        boxSizing: 'border-box',

        boxShadow: '0px 1px 3px 0px #0000001A',
      }}
    >
      <CardContent sx={{ textAlign: 'center' }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: '14px', sm: '16px', lg: '20px' },
            color: '#383838',
            fontWeight: 600,
            fontFamily: 'Jost , sans-serif',
          }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '24px', sm: '28px', lg: '36px' },
              color: environment.mainColor,
              fontWeight: 600,
              fontFamily: 'Jost , sans-serif',
            }}
          >
            {value}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '20px', sm: '24px' },
              color: environment.mainColor,
              fontWeight: 700,
              fontFamily: 'Jost , sans-serif',
            }}
          >
            Points
          </Typography>
        </Box>

        {subtitle && (
          <Typography
            sx={{
              fontSize: '16px',
              color: '#4A5565',
              fontFamily: 'Jost , sans-serif',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

RewardCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
};

RewardCard.defaultProps = {
  subtitle: '',
};

export default RewardCard;
